import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VideoSearch = _resolveComponent("VideoSearch");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_VideoSearch)]);
}